import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import moment from 'moment'
import { compose } from 'recompose'
import queryString from 'query-string'

import { Select } from 'components/fields'
import { apiCommon } from 'helpers/decorators/api'
import { addLocaleData } from 'react-intl'
import { form } from 'helpers/decorators'
import { localesDropdownSelector } from 'redux/selectors/locales'
import { changeLocale, onRefreshPage } from 'redux/modules/app'
import { getDictonary, toDash, toUnderscore, getLocaleFromStore } from 'utils/intl'

import removeUrlParam from 'utils/removeParamFromQuery'

const enhance = compose(
  apiCommon({
    locales: true
  }),
  connect(
    state => ({
      locale: state.app.locale,
      dropdownPersonLocales: localesDropdownSelector(state)
    }),
    { changeLocale, onRefreshPage, push }
  ),
  form({
    form: 'language-change'
  })
)

class LocaleSwitch extends Component {
  static propTypes = {
    dropdownPersonLocales: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    changeLocale: PropTypes.func.isRequired,
    onRefreshPage: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    locale: PropTypes.object.isRequired
  }

  state = {
    localeFromUrl: null
  }

  componentWillMount() {
    const { common } = this.props
    const cachedLocales = getLocaleFromStore()
    const locale = this.handleGetLocale(cachedLocales)

    moment.locale(locale)

    if (locale !== 'en-gb') {
      this.handleLocale(locale)
    }

    if (
      get(cachedLocales, 'code') &&
      get(cachedLocales, 'code') !== this.props.locale.code
    ) {
      this.props.changeLocale(cachedLocales)
    }

    if (common.locales.list.length > 0) {
      this.handleInitForm(common.locales.list, locale)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { locale, common } = this.props
    const cachedLocales = getLocaleFromStore()

    if (locale.code !== nextProps.locale.code) {
      this.handleLocale(nextProps.locale.code)
    }

    if (
      common.locales.list.length === 0 &&
      nextProps.common.locales.list.length > 0
    ) {
      this.handleInitForm(
        nextProps.common.locales.list,
        this.handleGetLocale(cachedLocales)
      )
    }
  }

  handleGetLocale = cachedLocales => {
    const query = queryString.parse(get(this.props, 'location.search'))

    if (get(query, 'locale')) {
      return this.handleSetLocaleFromUrl(get(query, 'locale'))
    }

    return (
      get(cachedLocales, 'code') || get(this.props, 'locale.code') || 'en-gb'
    )
  }

  handleSetLocaleFromUrl = locale => {
    return toDash(locale)
  }

  handleLocale = locale => {
    addLocaleData(getDictonary(locale))
    moment.locale(locale)
  }

  handleInitForm = (locales, locale) => {
    let initialLocale = locales.filter(
      item => item.code === String(toUnderscore(locale))
    )[0]

    if (!initialLocale) {
      console.warn('Unknown language')
      initialLocale = {}
    }

    this.props.initialize({
      language: {
        value: initialLocale.id,
        label: initialLocale.name
      }
    })
  }

  handleSelectChange = ({ value }) => {
    const { common, location } = this.props
    const locale = common.locales.list.filter(item => item.id === value)[0]

    this.props.changeLocale(locale)

    const hasLocaleParam = location.search.includes('locale')

    if (hasLocaleParam) {
      const newQueryString = removeUrlParam(location.search, 'locale')

      this.props.push(`${location.pathname}${newQueryString}`)
    }

    this.props.onRefreshPage(true)
  }

  render() {
    const { dropdownPersonLocales } = this.props

    return (
      <div>
        <Select
          name="language"
          label="Language"
          onSelectChange={this.handleSelectChange}
          labelless
          options={dropdownPersonLocales}
        />
      </div>
    )
  }
}

export default enhance(LocaleSwitch)
